export const MAX_VISIBLE_FACET_COUNT = 5

export const MODEL_EVENT = 'change'
